import {
  isHllApp,
  isWeixinBrowser,
  isAlipayMiniUa,
  isBaiduBoxUa,
  isWxMiniProgram
} from '@/utils';
export default () => {
  return isHllApp()
    ? 'HllApp'
    : isWxMiniProgram()
    ? '微信小程序'
    : isWeixinBrowser()
    ? '微信浏览器'
    : isAlipayMiniUa()
    ? '支付宝小程序'
    : isBaiduBoxUa()
    ? '百度小程序'
    : '其他浏览器';
};
